angular.module('SpidApp')

.factory('OperationalProduct', [function () {
	var OperationalProduct = function (params) {
		params = params || {}

		this.id         = params.id
		this.label      = params.label
	}
	
	return OperationalProduct
}])